import { z } from 'zod'

// Passed to the bulletin view so that its back link restores the selected filters
export const bulletinBoardLocationStateSchema = z.object({
  bulletinBoardSearch: z.string(),
})

export type BulletinBoardLocationState = z.infer<
  typeof bulletinBoardLocationStateSchema
>
